export default __webpack_public_path__ + "static/media/quotes.48edd6b2.svg";